import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "tournament", "homeTeam", "awayTeam" ]
  static values = { teamsMap: Object }

  connect() {
    this.updateTeamOptions()
  }

  tournamentChanged() {
    this.updateTeamOptions()
  }

  updateTeamOptions() {
    if (!this.hasTournamentTarget) return

    const tournamentId = parseInt(this.tournamentTarget.value)
    const tourneyTeamIds = new Set(this.teamsMapValue[tournamentId] || [])

    if (this.hasHomeTeamTarget) {
      this.groupSelectOptions(this.homeTeamTarget, tourneyTeamIds)
    }

    if (this.hasAwayTeamTarget) {
      this.groupSelectOptions(this.awayTeamTarget, tourneyTeamIds)
    }
  }

  groupSelectOptions(selectElement, tourneyTeamIds) {
    const selectedValue = selectElement.value
    
    // Gather all options across existing optgroups or flat list
    const allOptions = Array.from(selectElement.querySelectorAll("option")).map(opt => ({
      value: opt.value,
      text: opt.textContent,
      id: parseInt(opt.value)
    })).filter(opt => opt.value !== "")

    // Clear element
    selectElement.innerHTML = ""

    // Add prompt option
    const promptOption = document.createElement("option")
    promptOption.value = ""
    promptOption.textContent = "Select a team..."
    selectElement.appendChild(promptOption)

    const tournamentTeams = []
    const otherTeams = []

    allOptions.forEach(opt => {
      if (tourneyTeamIds.has(opt.id)) {
        tournamentTeams.push(opt)
      } else {
        otherTeams.push(opt)
      }
    })

    if (tournamentTeams.length > 0) {
      const tourneyGroup = document.createElement("optgroup")
      tourneyGroup.label = "🏆 Tournament Teams"
      tournamentTeams.forEach(opt => {
        const optionEl = document.createElement("option")
        optionEl.value = opt.value
        optionEl.textContent = opt.text
        if (opt.value === selectedValue) optionEl.selected = true
        tourneyGroup.appendChild(optionEl)
      })
      selectElement.appendChild(tourneyGroup)
    }

    if (otherTeams.length > 0) {
      const otherGroup = document.createElement("optgroup")
      otherGroup.label = tournamentTeams.length > 0 ? "🌐 Other Teams" : "All Teams"
      otherTeams.forEach(opt => {
        const optionEl = document.createElement("option")
        optionEl.value = opt.value
        optionEl.textContent = opt.text
        if (opt.value === selectedValue) optionEl.selected = true
        otherGroup.appendChild(optionEl)
      })
      selectElement.appendChild(otherGroup)
    }
  }
}
